import { memo } from 'react'
import { FormattedMessage } from 'react-intl'
import LineClockDollarIcon from 'LuxKit/Icons/line/LineClockDollarIcon'
import Pill from 'LuxKit/Pill'
import config from 'constants/config'

interface Props {
  testId?: string
  depositAmountPercentage?: number
}
function SecureWithDepositTag(props: Props) {
  const { testId, depositAmountPercentage } = props
  if (!config.DEPOSITS_TAGS_ENABLED) {
    return null
  }

  const depositLabel = depositAmountPercentage
    ? (
        <FormattedMessage
          id="xxPTLWw5nWKYSb7-FsdR"
          defaultMessage="Secure with a {percentage}% deposit"
          description="Tag label indicating the user can secure a booking with a specific deposit percentage"
          values={{ percentage: depositAmountPercentage }}
        />
      )
    : (
        <FormattedMessage
          id="6Cnf53uqrowISx6k6peC"
          defaultMessage="Secure with a deposit"
          description="Tag label indicating the user can secure a booking with a deposit"
        />
      )

  return (
    <Pill data-testid={testId} kind="tertiary" variant="primary" startIcon={<LineClockDollarIcon />}>
      {depositLabel}
    </Pill>
  )
}
export default memo(SecureWithDepositTag)
